const resources = {
    popularOffers: 'Offres populaires',
    signIn: 'Ouvrir une session',
    signInSubtitle: 'pour profiter d’offres exclusives'
};

export default function getResource(label) {
    return resources[label];
}
